import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DamageTypeColour } from 'src/app/model/ImageData/GICInformation';

@Component({
  selector: 'cell-gic-damage-type',
  template: `<div class="cell-values">
    <span class="chip" [style.background-color]="damageTypeColour[value] ?? '#7a7a7a'">
      {{ 'GICINFORMATION.' + value | translate | titlecase }}
    </span>
  </div>`,
  styles: [
    `
      .chip {
        color: white;
        padding: 0 5px 0 5px;
        border-radius: 15px;
      }
    `,
  ],
})
export class CellGicDamageTypeComponent implements ICellRendererAngularComp {
  public colId: string;
  public value: string;
  public damageTypeColour = DamageTypeColour;

  agInit(params: ICellRendererParams) {
    if (!params.value) {
      return;
    }

    this.colId = params.colDef.colId;
    this.value = params.data[this.colId];
  }

  public refresh(): boolean {
    return false;
  }
}
